import axios from 'axios';
import { API_URL } from '../config/api';

const otpService = {
  sendOtp: async (mobile) => {
    const response = await axios.post(`${API_URL}/otp/send`, { mobile });
    return response.data;
  },

  verifyOtp: async (mobile, otp) => {
    const response = await axios.post(`${API_URL}/otp/verify`, { mobile, otp });
    return response.data;
  },

  resendOtp: async (mobile) => {
    const response = await axios.post(`${API_URL}/otp/resend`, { mobile });
    return response.data;
  },

  sendEmailOtp: async (username, email) => {
    const response = await axios.post(`${API_URL}/email-otp/send`, { username, email });
    return response.data;
  },

  verifyEmailOtp: async (username, email, otp) => {
    const response = await axios.post(`${API_URL}/email-otp/verify`, { username, email, otp });
    return response.data;
  },

  resendEmailOtp: async (username, email) => {
    const response = await axios.post(`${API_URL}/email-otp/resend`, { username, email });
    return response.data;
  },
};

export default otpService;
